/* Tiny shared handle to the smooth-scroll instance, so components (Navbar
   menu, in-page anchors) can stop/start/scroll without prop drilling. */
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const isBrowser = typeof window !== 'undefined';

export function prefersReducedMotion() {
  return isBrowser && !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function hasFinePointer() {
  return isBrowser && !!window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

export const motion = {
  lenis: null,

  /** Scroll to a y value or element. offset defaults to the fixed nav height. */
  scrollTo(target, { immediate = false, offset } = {}) {
    const navH = (document.querySelector('.site-nav') || { offsetHeight: 0 }).offsetHeight;
    const off = offset !== undefined ? offset : (typeof target === 'number' ? 0 : -navH - 12);
    if (this.lenis) {
      this.lenis.scrollTo(target, { offset: off, immediate, force: true, duration: 1.3 });
      return;
    }
    const y = typeof target === 'number'
      ? target
      : target.getBoundingClientRect().top + window.pageYOffset + off;
    window.scrollTo({ top: y, behavior: immediate || prefersReducedMotion() ? 'auto' : 'smooth' });
  },

  /** Freeze page scroll (menu overlay open). */
  stop() {
    if (this.lenis) this.lenis.stop();
    document.documentElement.classList.add('is-scroll-locked');
  },

  start() {
    if (this.lenis) this.lenis.start();
    document.documentElement.classList.remove('is-scroll-locked');
  },

  refresh() {
    try { ScrollTrigger.refresh(); } catch (e) { /* noop */ }
  },

  /** QA helper: live ScrollTrigger / pin counts (used by _redesign/qa/nav.mjs). */
  stats() {
    const all = ScrollTrigger.getAll();
    return { triggers: all.length, pins: all.filter((t) => t.pin).length, pinSpacers: document.querySelectorAll('.pin-spacer').length };
  },
};

if (isBrowser) window.MoneliMotion = motion; // handy for page scripts / debugging
